import axios from 'axios';
import config from '../config';
import { getUser, removeUser } from '../utils/storageUtil';
import { Toast } from 'mint-ui';
let { protocol, host, port, prefix, postfix } = config.api;
/**
 *
 * @param {*} method
 * @param {*} url
 * @param {*} params get默认query，其他默认body
 * @param {*} paramType
 */
const requestPayload = async function(
  method = 'get',
  url,
  params = {},
  paramType,
  otherConfig = {}
) {
  const user = getUser();
  const token = user ? user.token : '';
  let headers = {
    'Content-Type':
      paramType === 'form' ? 'multipart/form-data' : 'application/json'
  };
  if (token) {
    headers.Authorization = token;
  }
  let payload = {
    method,
    // url: '/cors' + url,
    // url: 'http://ceshi.igreen.org/index.php/api' + url,
    // url: 'http://admin.igreen.org/index.php/api' + url,
    url: `${protocol}${host}${port}${prefix}${url}${postfix}`,
    headers,
    ...otherConfig
  };
  for (let prop in params) {
    if (params.hasOwnProperty(prop)) {
      if (!params[prop] && params[prop] !== 0) {
        delete params[prop];
      }
    }
  }

  if (paramType === 'query') {
    payload.params = params;
  } else {
    if (paramType === 'form') {
      let formData = new FormData();
      for (let prop in params) {
        if (params.hasOwnProperty(prop)) {
          formData.append(prop, params[prop]);
        }
      }
      payload.data = formData;
    } else {
      payload.data = params;
    }
  }
  return payload;
};

const apiUtil = {
  async get(url, params = {}, paramType = 'query') {
    const payload = await requestPayload('get', url, params, paramType);
    return new Promise((resolve, reject) => {
      axios(payload)
        .then(response => {
          const res = response.data;
          if (res.code === 200 && res.hasOwnProperty('data')) {
            resolve(res.data);
          } else {
            Toast(res.data.errorMessage);
          }
        })
        .catch(error => {
          const res = error.response;
          if (res && res.data) {
            Toast(res.data.errorMessage);
          } else {
            Toast('服务器请求失败');
          }
          reject(error);
        });
    });
  },

  async post(url, params = {}, paramType = 'body', otherConfig = {}) {
    const payload = await requestPayload(
      'post',
      url,
      params,
      paramType,
      otherConfig
    );
    return new Promise((resolve, reject) => {
      axios(payload)
        .then(response => {
          const res = response.data;
          if (res.code === 200 && res.hasOwnProperty('data')) {
            resolve({ success: true, orginite:res, ...res.data });
          } else if(res.code === 8001&& res.hasOwnProperty('data')){
            // window.wm.$router.push('/wechat');
            window.wm.$router.push({path:'/wechat',query:{user_auth_id:res.data.user_auth_id}});
            removeUser();
          }else{
            if(res.message!=''){
              Toast(res.message);
              if(res.code===3204){
                  setTimeout(function(){
                    window.wm.$router.push({path:'/my/wallet'});
                },2500);
              }
            }
            
            if (res.code === 1003) {
              window.wm.$router.push('/login');
              removeUser()
            }
          }
        })
        .catch(error => {
          const res = error.response;
          if (res && res.data) {
            if(res.message!=''){
              Toast(res.message);
            }
          } else {
            Toast('服务器请求失败');
          }
          reject(error);
        });
    });
  },

  async form(url, params = {}, paramType = 'form', otherConfig) {
    const payload = await requestPayload(
      'post',
      url,
      params,
      paramType,
      otherConfig
    );
    return new Promise((resolve, reject) => {
      axios(payload)
        .then(response => {
          const res = response.data;
          if (res.code === 200 && res.hasOwnProperty('data')) {
            resolve({ success: true, ...res.data });
          } else {
            Toast(res.message);
            if (res.code === 1003) {
              window.wm.$router.push('/login');
            }
          }
        })
        .catch(error => {
          const res = error.response;
          if (res && res.data) {
            Toast(res.message);
          } else {
            Toast('服务器请求失败');
          }
          reject(error);
        });
    });
  },

  async put(url, params = {}, paramType = 'body') {
    const payload = await requestPayload('put', url, params, paramType);
    return new Promise((resolve, reject) => {
      axios(payload)
        .then(response => {
          const res = response.data;
          if (res.code === 200 && res.hasOwnProperty('data')) {
            resolve(res.data);
          } else {
            Toast(res.data.errorMessage);
          }
        })
        .catch(error => {
          const res = error.response;
          if (res && res.data) {
            if (res.data.status === '099') {
              Toast('登录已超时');
              window.wm.$router.push('/login');
            } else {
              Toast(res.data.message);
            }
          } else {
            Toast('服务器请求失败');
          }
          reject(error);
        });
    });
  },

  async patch(url, params = {}, paramType = 'body') {
    const payload = await requestPayload('patch', url, params, paramType);
    return new Promise((resolve, reject) => {
      axios(payload)
        .then(response => {
          const res = response.data;
          if (res.code === 200 && res.hasOwnProperty('data')) {
            resolve(res.data);
          } else {
            Toast(res.data.errorMessage);
          }
        })
        .catch(error => {
          const res = error.response;
          if (res && res.data) {
            if (res.data.status === '099') {
              Toast('登录已超时');
              window.wm.$router.push('/login');
            } else {
              Toast(res.data.message);
            }
          } else {
            Toast('服务器请求失败');
          }
          reject(error);
        });
    });
  },

  async delete(url, params = {}, paramType = 'query') {
    const payload = await requestPayload('delete', url, params, paramType);
    return new Promise((resolve, reject) => {
      axios(payload)
        .then(response => {
          const res = response.data;
          if (res.code === 200 && res.hasOwnProperty('data')) {
            resolve(res.data);
          } else {
            Toast(res.data.errorMessage);
          }
        })
        .catch(error => {
          const res = error.response;
          if (res && res.data) {
            if (res.data.status === '099') {
              Toast('登录已超时');
              window.wm.$router.push('/login');
            } else {
              Toast(res.data.message);
            }
          } else {
            Toast('服务器请求失败');
          }
          reject(error);
        });
    });
  }
};

export default apiUtil;
